<template>
  <div style="height:100%; overflow:hidden">
    <div class="new-panel input-panel">
      <div class="title">法律声明</div>
      <h1>一、权利归属</h1>
      <p>
        1.1.
        智慧脸的“Logo”、“智慧脸”等文字、图形及其组合，以及智慧脸的其他标识、徽记、智慧脸服务的名称等为智慧脸及其关联公司在中国和其他国家的注册商标。未经智慧脸书面授权，任何人不得以任何方式展示、使用
        或做其他处理（包括但不限于复制、传播、展示、镜像、上传、下载），也不得向他人表明您有权展示、使用或做其他处理。
      </p>
      <p>1.2. 智慧脸所有的产品、服务、技术与所有程序（以下或简称“技术服务”）的知识产权均归属于智慧脸或归及其关联公司所有。</p>
      <p>
        1.3. 除非智慧脸另行声明，智慧脸拥有在智慧脸平台内发布文档等信息（包括但不限于文字、图形、图片、照
        片、音频、视频、图标、色彩、版面设计、电子文档）的所有权利（包括但不限于版权、商标权、专利权、
        商业秘密和其他所有相关权利）。未经智慧脸许可，任何人不得擅自使用如上内容（包括但不限于通过程序或
        设备监视、复制、转播、展示、镜像、上传、下载智慧脸相关网站或移动应用程序内的任何内容）。被授权浏览、复制、打印和传播属于智慧脸相关网站或移动应用程序内信息内容的，该等内容都不得用于商业目的且所有信息内容及其任何部分的使用都必须包括此权利声明。
      </p>
      <h1>二、责任限制</h1>
      <p>
        2.1.
        用户在智慧脸平台的评论、社区以及其他应用上，自行上传、提供、发布相关信息，包括但不限于用户名称、公司名称、联系人及联络信息，相关图片、资讯等，该等信息均由用户自行提供，用户须对其提供的任何信息依法承担全部责任。
      </p>
      <p>2.2. 智慧脸平台上转载内容出于传递更多信息之目的，并不意味智慧脸赞同其观点或证实其内容的真实性。</p>
      <p>
        2.3.
        智慧脸在此提示，您在使用智慧脸服务期间应当遵守中华人民共和国的法律，不得危害网络安全，不得利用智慧脸的服务从事他人侵犯名誉、隐私、知识产权和其他合法权益的活动。尽管有前述提示，智慧脸不对您使用智慧脸服务的用途和目的承担任何责任。
      </p>
      <h1>三、知识产权保护</h1>
      <p>
        我们尊重知识产权，反对并打击侵犯知识产权的行为。任何组织或个人认为智慧脸的网页内容（如转载文章、发布的信息等）可能侵犯其合法权益的，可以通过向智慧脸提出书面权利通知，智慧脸将在收到知识产权权利人合格通知后依法尽快处理。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "legalStatement",
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped lang="scss">
.new-panel {
  padding: 32px 16px 16px 16px;
  color: #4d4d4d;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  p {
    font-size: 16px;
    font-family: "PingFangSC-Regular", "PingFang SC";
    font-weight: 400;
    line-height: 22px;
    margin: 12px 0;
    padding: 0;
  }
  h1 {
    height: 25px;
    font-size: 18px;
    font-family: "PingFangSC-Semibold", "PingFang SC";
    font-weight: 600;
    line-height: 25px;
    padding: 0;
    margin: 8px 0;
  }
  .textIndent {
    text-indent: 2em;
  }
  .hr_ {
    color: #4d4d4d;
    margin-bottom: 20px;
  }
}
.title {
  text-align: center;
  width: 266px;
  font-size: 19px;
  font-family: "PingFangSC-Semibold", "PingFang SC";
  font-weight: 600;
  color: rgba(34, 34, 34, 1);
  margin: 0 auto;
}
</style>
